import Juggling from "./Juggling"

export default function JugglingBig() {
  return (
    <div className="flex items-center justify-center p-10">
      <Juggling size={120} />
    </div>
  )
}
